module.exports = __webpack_public_path__ + "static/facebook-btn-07ca7cc78b38b33fa0012878427aff6f.svg";